var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHashSmall = function SvgHashSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hash-small_svg__a",
    width: "105.8%",
    height: "105.7%",
    x: "-2.9%",
    y: "-2.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0.304622592 0 0 0 0 0.578497024 0 0 0 0.129971591 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hash-small_svg__b",
    d: "M0 0h800v812H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8F9",
    d: "M-624-618H816V438H-624z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -414)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hash-small_svg__b",
    fill: "#000",
    filter: "url(#hash-small_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hash-small_svg__b",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M10 .833a9.167 9.167 0 1 1 0 18.334A9.167 9.167 0 0 1 10 .833m0 .834a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666m3.24 3.409c.223.056.36.282.304.505l-.48 1.918 1.52.001a.417.417 0 1 1 0 .833h-1.727l-.832 3.333h2.558a.417.417 0 1 1 0 .834h-2.765l-.492 1.976a.417.417 0 1 1-.809-.202l.442-1.775H8.07l-.493 1.977a.417.417 0 0 1-.809-.202l.442-1.775-1.792.001a.417.417 0 1 1 0-.833h2l.831-3.334H5.417a.417.417 0 1 1 0-.833h3.04l.528-2.12a.417.417 0 0 1 .809.201L9.314 7.5h2.892l.53-2.12a.417.417 0 0 1 .504-.303m-2.073 6.59.831-3.333h-2.89l-.833 3.333z"
  }))));
};
export default SvgHashSmall;